import { render } from "./DMSClaimsReport.vue?vue&type=template&id=1b3beffa"
import script from "./DMSClaimsReport.vue?vue&type=script&lang=js"
export * from "./DMSClaimsReport.vue?vue&type=script&lang=js"

import "./DMSClaimsReport.vue?vue&type=style&index=0&id=1b3beffa&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__